import { formatUnits, parseUnits } from 'viem';

/**
 * Converts a human-readable token amount to raw units for API submission.
 * Example: "5.12345" with 6 decimals → "5123450"
 *
 * @param humanAmount - Human-readable amount (e.g., "5.12345")
 * @param decimals - Token decimals (e.g., 6 for USDC, 18 for ETH)
 * @returns Raw amount as string for API submission
 */
export function toRawTokenUnits(humanAmount: string, decimals: number): string {
  return parseUnits(humanAmount, decimals).toString();
}

/**
 * Converts raw token units to human-readable format for display.
 * Example: "5123450" with 6 decimals → "5.12345"
 *
 * @param rawAmount - Raw amount from API (e.g., "5123450")
 * @param decimals - Token decimals (e.g., 6 for USDC, 18 for ETH)
 * @returns Human-readable amount string
 */
export function toHumanReadableTokenAmount(
  rawAmount: string,
  decimals: number
): string {
  return formatUnits(BigInt(rawAmount), decimals);
}
